// Main javascript entry point
// Should handle bootstrapping/starting application


'use strict';

import './vendor/slick.min.js';
import $ from 'jquery';
import Header from '../_modules/header/header';
import Menu from '../_modules/menu/menu';
import Expand from '../_modules/expand/expand';
import SliderContent from '../_modules/sliderContent/sliderContent';
//import SliderVideo from '../_modules/sliderVideo/sliderVideo';
import Video from '../_modules/videos/video';
import Search from '../_modules/search/search';
import Footer from '../_modules/footer/footer';
import Forms from '../_modules/forms/forms';

$(() => {
	new Menu();
	new Header();
	
	var $mobile = $(window).outerWidth() < 769;
	window.addEventListener("orientationchange", function() {
		location.reload();
	}, false);

	
	$('.scroll-down').on('click',function(){
		$('html,body').animate({
			scrollTop: $('.content-block').offset().top - 105 // banner height
		},500);
	});
	
				
	$('.checkMember').on('click',function(e){
			$('.modal').show();
			e.preventDefault;

	})
	
	if (!$mobile){
		$('video').on('click',function(){
			this.paused?this.play():this.pause();
		});
		$('.img-swap').each(function(){
			var $newImg = $(this).data('desktop');
			$(this).attr('src', $newImg);
		});
	} else {
		$('.img-swap').each(function(){
			var $newImg = $(this).data('mobile');
			$(this).attr('src', $newImg);
		});
	}
	
//	if($('.topic-block').length > 0){
//        var $val = $('.topic-select').val(),
//			$url = 'ajax/' + $val + '.json';
//        
//        ajaxCall($url)
//        
//		$('.topic-select').on('change',function(){
//            $val = $(this).val();
//            $url = 'ajax/' + $val + '.json';
//            
//            ajaxCall($url);
//        });
//        
//        function ajaxCall($url){
//             $.ajax({ //set up the ajax request
//                url:$url,
//                dataType:'json',
//            }).done(function(data){
//                var items = [];
//                $.each(data,function(key,val){ //build
//                    items.push('<div class="topic-content"><div class="content-txt blue"><h3>'+ val.title +'</h3><p>'+ val.intro +'</p></div><div class="content-txt"><h2>'+ val.subtitle +'</h2><p>'+ val.content +'</p></div><div class="content-txt yellow"><a class="btn" href='+ val.link+'>' + val.linkTxt + '</a></div></div>');
//                });
//
//                $('.topic-content').replaceWith(items.join(''));//append the items
//            }).fail(function(){ //failed condition for load the json
//                alert('failed to load');
//            }); 
//        }
//        
//	}
	$('.modal-close').on('click',function(){
		$('.modal').fadeOut();
	})
	
    if($('.slider-holder').length > 0){
			
        $(".slider-video").slick({
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 4,
            arrows: false,
            responsive:[
                {
                  breakpoint: 1330,
                  settings: {
                    centerMode: true,
                    slidesToShow: 2,
                    slidesToScroll: 2
                  }
                },
                {
                  breakpoint: 767,
                  settings: {
                    centerMode: true,
                    centerPadding: '20%',
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
            ]
        });
    }
    
	new Expand();
	new SliderContent();
	//new SliderVideo();
	new Video();
	new Search();
	new Footer();
	new Forms();
});